import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../_services/authentication.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) { }
  public getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    // console.log(document.cookie);
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    // console.log('JwtInterceptor: ', request);
    const token = localStorage.getItem("token");
    const csrfToken = this.getCookie('XSRF-TOKEN')
    const cookieheaderName = 'X-XSRF-TOKEN';
    
    if(token) {
      if (request.url.indexOf("s3.sa-east-1") === -1) {
        request = request.clone({
          setHeaders: {
            'Authorization': `Bearer ${token}`,
            'X-XSRF-TOKEN' : csrfToken
          },
          withCredentials: true
        });
      }

    } else {
      request = request.clone(
        { headers: request.headers.set(cookieheaderName, csrfToken),
          withCredentials: true});
    }

    return next.handle(request);
  }
}
